import React from 'react';

import { LocationContainer } from './LocationCards.styled';
import NewLocationCard from '../../../components/NewLocationCard';

import { Props } from './LocationCards.types';

export const LocationCards = ({
  clinics = [],
  clinicsHasAppointments,
  selectedClinic,
  onSelectClinic
}: Props) => {
  let clinicsCards: React.ReactNode[] = [];

  if (clinicsHasAppointments) {
    clinicsCards = clinics.map(clinic => (
      <NewLocationCard
        key={clinic.id}
        name={clinic.name}
        address={clinic.address}
        imageUrl={clinic.imageUrl}
        selected={selectedClinic?.id === clinic.id}
        onSelect={() => onSelectClinic(clinic)}
      />
    ));
  }

  return (
    <LocationContainer $centerContent={clinicsCards.length <= 2}>{clinicsCards}</LocationContainer>
  );
};
